export const EVENT_GROUPS = [
  {
    org: 'GDG Gandhinagar & GDG Cloud Gandhinagar',
    color: '#4285F4',
    events: [
      { date: '01 Nov 2026', name: 'DevFest Gandhinagar 26', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '26 Sep 2026', name: 'Code With Kids', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '01 Aug 2026', name: 'Antigravity Final Series', chapter: 'GDG Cloud Gandhinagar + GDG Gandhinagar' },
      { date: '26 Jul 2026', name: 'Build With Antigravity – Final Edition', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '14 Jun 2026', name: 'Build with Antigravity Series : Part 3', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '21 May 2026', name: 'Agentic Premier League - Gandhinagar', chapter: 'GDG Cloud Gandhinagar' },
      { date: '12 May 2026', name: 'Agent Premier League (APL) Watch Party & Tech Meetup', chapter: 'GDG Gandhinagar' },
      { date: '15 Mar 2026', name: 'Build with Antigravity Series : Part 2', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '22 Feb 2026', name: 'Build with Antigravity Series : Part 1', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '24 Jan 2026', name: 'Fortified Intelligence - Architecting Secure, Hybrid AI Networks on Google Cloud', chapter: 'GDG Cloud Gandhinagar' },
      { date: '10 Jan 2026', name: "AutonomousHacks '26: Offline Finale", chapter: 'GDG Gandhinagar' },
      { date: '06 Jan 2026', name: 'AutonomousHacks: MVP Growth Strategies', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '03 Jan 2026', name: 'From Hackathon Project to Product: A Journey with Shubham Pachori', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '20 Dec 2025', name: 'Autonomous Hacks Hackathon', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '20 Dec 2025', name: 'Hackathon KickOff Session', chapter: 'GDG Cloud Gandhinagar' },
      { date: '17 Dec 2025', name: 'Kickstart to Google ADK and Hackathon AMA', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '16 Nov 2025', name: 'Developing and Deploying Cloud-Native Application Securely Using Workload Identity Federation', chapter: 'GDG Cloud Gandhinagar' },
      { date: '02 Nov 2025', name: 'Devfest Gandhinagar', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '26 Oct 2025', name: 'Modern Application Scaling on Google Cloud: Why GKE?', chapter: 'GDG Cloud Gandhinagar' },
      { date: '11 Oct 2025', name: 'Build & Scale on GCP: From Code to Scalable Cloud Deployment', chapter: 'GDG Cloud Gandhinagar' },
      { date: '28 Sep 2025', name: 'Building with Google AI Studio & Vertex AI', chapter: 'GDG Cloud Gandhinagar' },
      { date: '27 Sep 2025', name: 'Google Gemini and ADK with GCP Workshop', chapter: 'GDG Gandhinagar' },
      { date: '20 Sep 2025', name: 'Google ADK Multi-Agent Stock Analyzer Workshop', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '23 Aug 2025', name: 'Design, Build & Optimize: Modern App Development in Flutter', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '05 Jul 2025', name: 'Google Cloud Community Day Gandhinagar 2025', chapter: 'GDG Cloud Gandhinagar' },
      { date: '29 Jun 2025', name: 'Google Cloud Community Day Gandhinagar 2025: Pre-Event Workshop', chapter: 'GDG Cloud Gandhinagar' },
      { date: '07 Jun 2025', name: "Build with AI - Let's Vibe Code Together", chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '20 May 2025', name: 'Google I/O 2025 Extended Watch Party Gandhinagar', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '03 May 2025', name: 'Build with AI - Gandhinagar', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '06 Apr 2025', name: 'Redefine Possible Gandhinagar #IWD2025', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '01 Mar 2025', name: 'GDG GNR Networking Dinner: Where Tech Meets Conversations and Experiences', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '15 Feb 2025', name: 'Observability Meetup GIFT City', chapter: 'GDG Cloud Gandhinagar' },
      { date: '25 Jan 2025', name: 'The Future of Fintech: AI-Powered Innovation on Google Cloud', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '14 Dec 2024', name: 'Tech Talk with AI Experts 🚀', chapter: 'GDG Cloud Gandhinagar' },
      { date: '30 Nov 2024', name: 'AI Meetup Collaboration', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '16 Nov 2024', name: 'Cloud Tech Takeover: Hashicorp User Group Gandhinagar & GDG Cloud Gandhinagar Join Forces Again!', chapter: 'GDG Cloud Gandhinagar' },
      { date: '20 Oct 2024', name: 'Devfest Gandhinagar', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '13 Oct 2024', name: 'Open Source Day X Hacktoberfest 2024', chapter: 'GDG Gandhinagar + GDG Cloud Gandhinagar' },
      { date: '26 Sep 2024', name: 'Zero Trust, Max Security: Safeguarding Cloud Systems', chapter: 'GDG Cloud Gandhinagar' },
      { date: '06 Jul 2024', name: 'AI Day', chapter: 'GDG Gandhinagar' },
      { date: '08 Jun 2024', name: 'Chai Meetup', chapter: 'GDG Gandhinagar' },
    ],
  },
  {
    org: 'ExploitXplorers',
    color: '#16A085',
    events: [
      { date: '03 Feb 2024', name: 'Live Practical Cybersecurity Workshop', chapter: 'ExploitXplorers' },
      { date: '03 May 2024', name: 'AI Conclave Ahmedabad 2024', chapter: 'ExploitXplorers' },
      { date: '18 May 2024', name: 'CodeCrack 2.0 – AI in Cybersecurity', chapter: 'ExploitXplorers' },
      { date: '06 Jul 2024', name: 'AI Day', chapter: 'ExploitXplorers' },
      { date: '03 Aug 2024', name: 'Ethical Hacking Workshop', chapter: 'ExploitXplorers' },
      { date: '26 Sep 2024', name: 'Zero Trust, Max Security: Safeguarding Cloud Systems', chapter: 'ExploitXplorers' },
      { date: '13 Oct 2024', name: 'Open Source Day X Hacktoberfest 2024', chapter: 'ExploitXplorers' },
      { date: '16 Nov 2024', name: 'Cloud Tech Takeover', chapter: 'ExploitXplorers' },
      { date: '30 Nov 2024', name: 'AI Meetup Collaboration', chapter: 'ExploitXplorers' },
      { date: '14 Dec 2024', name: 'Tech Talk with AI Experts', chapter: 'ExploitXplorers' },
      { date: '2024', name: 'SecureDroid – Cybersecurity & Android Development Workshop', chapter: 'ExploitXplorers' },
    ],
  },
  {
    org: 'GDG on Campus: Silver Oak University',
    color: '#0F9D58',
    events: [
      { date: '2020', name: 'Google Cloud Ready Facilitator Program', chapter: 'GDG SOU' },
      { date: '2022', name: 'Google Cloud Career Readiness Program', chapter: 'GDG SOU' },
      { date: '20 Sep 2024', name: 'GDG Orientation 2024', chapter: 'GDG SOU' },
      { date: '11 Oct 2024', name: 'Build with AI – Gen AI Study Jams', chapter: 'GDG SOU' },
      { date: '2024', name: 'Google Cloud Gen AI Study Jams Recognition', chapter: 'GDG SOU' },
      { date: '19 Nov 2024', name: 'Git & GitHub Workshop', chapter: 'GDG SOU' },
      { date: '29 Dec 2024', name: 'Tech Winter Break', chapter: 'GDG SOU' },
      { date: 'Early 2025', name: 'TechSprint Hackathon', chapter: 'GDG SOU' },
      { date: '22 Mar 2025', name: 'The Next Frontier: AI in Healthcare', chapter: 'GDG SOU' },
      { date: '2025', name: 'Community Partnerships with DevFest, Build with AI & Google for Developers Initiatives', chapter: 'GDG SOU' },
      { date: '10 Jan 2026', name: "AutonomousHacks '26 Finale", chapter: 'GDG SOU' },
      { date: '21 Mar 2026', name: 'From Idea to App: Building Smarter Apps with Antigravity', chapter: 'GDG SOU' },
      { date: '04 Apr 2026', name: 'PromptWars Hackathon', chapter: 'GDG SOU' },
    ],
  },
  {
    org: 'JavaScript Gujarat',
    color: '#F7DF1E',
    events: [
      { date: '20 Sep 2025', name: 'JavaScript Gujarat Meetup #1 – Ahmedabad', chapter: 'JavaScript Gujarat' },
      { date: '29 Nov 2025', name: 'JavaScript Gujarat Meetup #2 – Gandhinagar', chapter: 'JavaScript Gujarat' },
      { date: '01 Feb 2026', name: 'JS Gujarat × GDG Rajkot Meetup', chapter: 'JavaScript Gujarat + GDG Rajkot' },
      { date: '14 Mar 2026', name: 'JS Meetup Surat', chapter: 'JavaScript Gujarat' },
    ],
  },
  {
    org: 'Laracon India',
    color: '#FF2D20',
    events: [
      { date: '30–31 Jan 2026', name: 'Laracon India Conference', chapter: 'Laracon India' },
    ],
  },
  {
    org: 'Open Source Weekend',
    color: '#1A1A2E',
    events: [
      { date: '2025', name: 'Open Source Day 2025', chapter: 'Open Source Weekend' },
      { date: '2026', name: 'Open Source Day 2026', chapter: 'Open Source Weekend' },
    ],
  },
  {
    org: 'Pixelverse Community',
    color: '#6C3483',
    events: [
      { date: '05 Jul 2026', name: 'Figma Master Class', chapter: 'Pixelverse Community' },
      { date: '04 Jul 2026', name: 'Webflow Meetup July #2', chapter: 'Pixelverse Community' },
      { date: '27 Sep 2025', name: 'Open Source with AI Workshop | Open Source Day 2025', chapter: 'Pixelverse Community' },
      { date: '24 Jan 2026', name: 'How to Create a Design System', chapter: 'Pixelverse Community' },
      { date: '21 Feb 2026', name: 'How To Design A Logo!!', chapter: 'Pixelverse Community' },
      { date: '21 Mar 2026', name: 'Canva Masterclass', chapter: 'Pixelverse Community' },
      { date: '09 May 2026', name: 'Build with AI : Vibe Coding with Google Antigravity', chapter: 'Pixelverse Community' },
      { date: '30 May 2026', name: 'Learn to Think Like Users', chapter: 'Pixelverse Community' },
    ],
  },
  {
    org: 'Silver Oak University IEEE SB',
    color: '#00629B',
    events: [
      { date: '25 Oct 2023', name: 'Book Review: Five Little Pigs', chapter: 'IEEE SOU SB' },
      { date: '30 Oct 2023', name: 'Git/GitHub Workshop', chapter: 'IEEE SOU SB' },
      { date: '31 Oct 2023', name: 'Murder Mystery', chapter: 'IEEE SOU SB' },
      { date: '15 Jan 2024', name: 'Introduction to Serverless on AWS', chapter: 'IEEE SOU SB' },
      { date: '18 Feb 2024', name: 'Book Review – The Untethered Soul', chapter: 'IEEE SOU SB' },
      { date: '18 Feb 2024', name: 'Full Stack Innovations', chapter: 'IEEE SOU SB' },
      { date: '18 Feb 2024', name: '15 Days Internship Program on Android App Development with Java', chapter: 'IEEE SOU SB' },
      { date: '05 Mar 2024', name: 'Navigate IT Odyssey: Career Mapping', chapter: 'IEEE SOU SB' },
      { date: '02 Apr 2024', name: 'Geek Out: Chatbots and LLM in a Day', chapter: 'IEEE SOU SB' },
      { date: '03 Apr 2024', name: 'Brave Together: Mental Health Awareness', chapter: 'IEEE SOU SB' },
      { date: '03 Apr 2024', name: 'SHE 2.0: Strong, Happening, Empowered', chapter: 'IEEE SOU SB' },
      { date: '04 Apr 2024', name: 'Cloudera Quickstart for Hadoop', chapter: 'IEEE SOU SB' },
      { date: '04 Apr 2024', name: 'SafeSphere: Addressing Workplace Harassment', chapter: 'IEEE SOU SB' },
      { date: '06 Apr 2024', name: 'Mindful Leadership: Harnessing Spirituality for Professional Growth', chapter: 'IEEE SOU SB' },
      { date: '06 Apr 2024', name: 'PARAM Shavak Preview: A Glimpse into Supercomputing Excellence', chapter: 'IEEE SOU SB' },
      { date: '07 Apr 2024', name: 'Campus Hero Webinar', chapter: 'IEEE SOU SB' },
      { date: '07 Apr 2024', name: 'Python 101', chapter: 'IEEE SOU SB' },
      { date: '07 Apr 2024', name: 'PARAM Shavak: ML Unleashed', chapter: 'IEEE SOU SB' },
      { date: '07 Apr 2024', name: 'PARAM Shavak Deep Dive: Mastering Machine Learning', chapter: 'IEEE SOU SB' },
      { date: '19 Apr 2024', name: 'Oracle Cloud Day – Ahmedabad', chapter: 'IEEE SOU SB' },
      { date: '20 Apr 2024', name: 'Artful Minds 2.0', chapter: 'IEEE SOU SB' },
      { date: '24 Apr 2024', name: 'Edu-Talk: Introduction to Ethical Hacking', chapter: 'IEEE SOU SB' },
      { date: '24 Apr 2024', name: 'Edutalk: Mass Mailing and Mail Template Using HTML & CSS 2.0', chapter: 'IEEE SOU SB' },
      { date: '28 Apr 2024', name: 'Charging Up: The Future of EV Networks', chapter: 'IEEE SOU SB' },
      { date: '30 Apr 2024', name: 'IEEE SIGHT Day Celebration 2024', chapter: 'IEEE SOU SB' },
      { date: '03 May 2024', name: 'Pages Unfolded', chapter: 'IEEE SOU SB' },
      { date: '05 May 2024', name: 'AI Conclave Ahmedabad 2024', chapter: 'IEEE SOU SB' },
      { date: '20 May 2024', name: 'Power Within Mindset', chapter: 'IEEE SOU SB' },
      { date: '20 May 2024', name: 'SafeTouch', chapter: 'IEEE SOU SB' },
      { date: '18 Jun 2024', name: 'Curtain Raiser: Student Chapter Congress Networking Meet', chapter: 'IEEE SOU SB' },
      { date: '02 Jul 2024', name: 'Book Review – The Kite Runner', chapter: 'IEEE SOU SB' },
      { date: '16 Jul 2024', name: 'Workshop on Security Monitoring', chapter: 'IEEE SOU SB' },
      { date: '12 Sep 2024', name: 'ConnectWISE', chapter: 'IEEE SOU SB' },
      { date: '28 Sep 2024', name: 'Template Protection of Biometric', chapter: 'IEEE SOU SB' },
      { date: '28 Sep 2024', name: 'Wrath of Words 2.0', chapter: 'IEEE SOU SB' },
      { date: '28 Sep 2024', name: 'Intel Distribution of OpenVINO Toolkit Online Training', chapter: 'IEEE SOU SB' },
      { date: '28 Sep 2024', name: 'Murder Mystery 2.0', chapter: 'IEEE SOU SB' },
      { date: '29 Sep 2024', name: 'CySec', chapter: 'IEEE SOU SB' },
      { date: '29 Sep 2024', name: 'Visualize and Design Your Serverless Application', chapter: 'IEEE SOU SB' },
    ],
  },
  {
    org: 'vizchitra',
    color: '#EC4899',
    events: [
      { date: '3–4 Jul 2026', name: 'vizchitra Conference 26', chapter: 'vizchitra' },
    ],
  },
  {
    org: 'GDG Ahmedabad (WTM)',
    color: '#34A853',
    events: [
      { date: '18 Apr 2026', name: 'WTM Ahmedabad IWD26', chapter: 'GDG Ahmedabad' },
    ],
  },
  {
    org: 'CNCF Ahmedabad',
    color: '#326CE5',
    events: [
      { date: '19 Sep 2026', name: "KCD Gujarat '26", chapter: 'CNCF Ahmedabad' },
    ],
  },
  {
    org: 'Agent Nexus',
    color: '#4A90E2',
    events: [
      { date: '4 Sep 2026', name: "Agent Nexus '26", chapter: 'Agent Nexus' },
    ],
  },
  {
    org: 'H2skill & Google For Developers',
    color: '#FBBC04',
    events: [
      { date: '12 Jun 2026', name: "Prompt War '26", chapter: 'H2skill & Google For Dev' },
    ],
  },
  {
    org: 'GDG Baroda',
    color: '#4285F4',
    events: [
      { date: '25 Oct 2026', name: 'DevFest Baroda 2026', chapter: 'GDG Baroda' },
    ],
  },
];

export const TOTAL_EVENTS = EVENT_GROUPS.reduce((s, g) => s + g.events.length, 0);
